import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";

import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input";
import {Messages} from "../../../../../Messages";
import {AmazonPayLogo, AmExIcon, MasterCardIcon, VisaIcon} from "../../../../../SVGElements";
import {styleRule, styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {
    StripeCardInput,
    StripeCardInputStyle
} from "../../../../../website/authenticated/pages/wallet/components/cards/CardInput";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../../../Utils";
import {STRIPE_CARD_ERROR_MAX_LENGTH} from "../../../../../Constants";
import {isFirefox} from "../../../../../Utils";
import {isSmallScreen} from "../../../../../UtilsLib";
import {apiAddPaymentMethodToken} from "../../../../../../client/state/PaymentMethodStore";
import {iFrameMerchantService} from "blinkpay/services/IframeMerchantService";
import {BlinkCardInput} from "../../../../../website/authenticated/pages/wallet/components/cards/BlinkCardInput";
import {Controller} from "../../../../Controller";
import {Button} from "../../../../../../stem-core/src/ui/button/Button.jsx";
import {AmazonPayWidget} from "../../../../../website/authenticated/pages/wallet/components/cards/AmazonPay.jsx";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives.jsx";
import {PaymentProcessorStore, PaymentProcessorType} from "../../../../../../client/state/PaymentProcessorStore.js";


export class CardInputStyle extends StripeCardInputStyle {
    @styleRuleInherit
    element = {
        position: "relative",
        overflow: "initial",
    };

    @styleRuleInherit
    inputContainer = {
        background: this.themeProps.MERCHANT_INPUT_BACKGROUND,
        borderRadius: this.themeProps.MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS,
        padding: isSmallScreen() ? "0.25rem 5px 0.25rem 12px" : "",
        border: () => "1px solid " + this.themeProps.MERCHANT_INPUT_BORDER_COLOR,
        height: 42,
        transition: "box-shadow 0.2s ease",
        ...this.themeProps.MERCHANT_INPUT_STYLE,
    };

    @styleRuleInherit
    focused = {
        border: () => "1px solid " + this.themeProps.MERCHANT_INPUT_BORDER_ACTIVE_COLOR,
    };

    @styleRuleInherit
    error = {
        borderColor: this.themeProps.MERCHANT_ERROR,
        ":hover": {
            borderColor: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input::placeholder": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        }
    };

    @styleRuleInherit
    errorMessage = {
        position: "absolute",
        top: -6,
        paddingBottom: 0,
        left: 0,
        transform: "translateY(calc(-100%))",
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        color: this.themeProps.MERCHANT_ERROR,
        marginTop: 0,
    };
}

@registerStyle(CardInputStyle)
export class CardInput extends StripeCardInput {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            autofocus: false,
            stripeStyle: {
                base: {
                    fontSize: this.styleSheet.themeProps.MERCHANT_FONT_SIZE_LARGE,
                    color: this.styleSheet.themeProps.MERCHANT_INPUT_TEXT_COLOR,
                    iconColor: this.styleSheet.themeProps.MERCHANT_INPUT_TEXT_COLOR,
                    fontFamily: this.styleSheet.themeProps.MERCHANT_FONT_FAMILY,
                    "::placeholder": {
                        color: this.styleSheet.themeProps.MERCHANT_INPUT_PLACEHOLDER_COLOR,
                        fontWeight: this.styleSheet.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
                    },
                },
            },
        };
    }

    confirmCardWithoutStoring(scope, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION, data = {}) {
        const {paymentProcessor} = this.options;
        this.updateOptions({error: null});
        this.stripe.createToken(this.card, data).then(async response => {
            if (response.error) {
                this.error = response.error.message.length > STRIPE_CARD_ERROR_MAX_LENGTH ?
                    Messages.genericCardError.toString() : response.error.message;
                this.redraw();
                errorCallback();
            } else {
                this.card.blur();
                try {
                    const addPaymentMethodResponse = await apiAddPaymentMethodToken(
                        response.token,
                        scope,
                        paymentProcessor
                    );
                    callback(addPaymentMethodResponse)
                } catch (error) {
                    this.error = error.message.length > STRIPE_CARD_ERROR_MAX_LENGTH ?
                        Messages.genericCardError.toString() : error.message;
                    this.redraw();
                    errorCallback(error);
                }
            }
        });
    }
}

class CardFormStyle extends StyleSheet {
    @styleRule
    cardIcons = {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 10,
    };

    @styleRule
    cardIcon = {
        marginLeft: 8,
    };

    @styleRule
    link = {
        marginTop: 8,
        display: "flex",
        ...this.themeProps.PANEL_LINK,
    };
}

export class NameInputStyle extends BlinkInputStyle {
    @styleRuleInherit
    input = {
        "-webkit-text-stroke-width": isSmallScreen() ? 0 : ".2px",
        fontSize: () => this.themeProps.MERCHANT_FONT_SIZE_LARGE + " !important",
        "::placeholder": {
            textShadow: (isFirefox() ? "0px" : "0.2px") + `0px 0px ${this.themeProps.MERCHANT_INPUT_PLACEHOLDER_COLOR}`,
            opacity: 1,
        },
    };

    @styleRuleInherit
    error = {
        borderColor: this.themeProps.MERCHANT_ERROR,
        ":hover": {
            borderColor: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        },
        " input::placeholder": {
            color: this.themeProps.MERCHANT_ERROR + " !important",
        }
    };
}

@registerStyle(NameInputStyle)
export class NameInput extends BlinkInput {}

@registerStyle(CardFormStyle)
export class CardForm extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            onChange: NOOP_FUNCTION,
            NameInputClass: NameInput,
            CardInputClass: CardInput,
        }
    }

    updateAmazonPayOrderId(amazonPayOrderId) {
        Controller.paymentMethod.setAmazonPayOrderId(amazonPayOrderId);
        this.options.onChange(); // This will redraw the parent component. TODO @cleanup bad pattern
    }

    getAltPaySection() {
        const amazonPaymentProcessor = PaymentProcessorStore.findBy({
            merchantId: iFrameMerchantService.merchantId,
            provider: PaymentProcessorType.AMAZON,
        });

        if (amazonPaymentProcessor == null) {
            return null;
        }

        const useAmazonPay = () => AmazonPayWidget.requestWidgetInSDK(amazonPaymentProcessor, (amazonPayOrderId) => {
            this.updateAmazonPayOrderId(amazonPayOrderId);
        });

        return <div>
            <div style={{textAlign: "center"}}>
                <Button style={{
                    width: "100%",
                    maxWidth: "368px",
                    margin: "auto",
                    padding: "11px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                        onClick={useAmazonPay}>
                    <AmazonPayLogo style={{display: "inline-block", lineHeight: 0, marginTop: 2}}/>
                </Button>
            </div>
            <div style={{textAlign: "center", paddingTop: 12}}>
                Or enter your card details bellow
            </div>
        </div>
    }

    render() {
        const {styleSheet} = this;
        const {NameInputClass, CardInputClass} = this.options;
        const creditCardIconSize = 12;

        const CardInput = iFrameMerchantService.isCDSPaymentMethod() ? BlinkCardInput : CardInputClass;


        const altPaySelected = Controller.paymentMethod.haveAltPaymentEnabled();

        return altPaySelected ?
            <div>
                You have selected Amazon Pay for this payment.
                <Link
                    className={styleSheet.link}
                    onClick={() => this.updateAmazonPayOrderId(null)}
                >Use another payment method?</Link>
            </div> : [
                this.getAltPaySection(),

                <NameInputClass inputAttributes={{placeholder: Messages.addCardNameInput.toString(), autofocus: true}}
                                ref="nameInput" initialValue={Controller.paymentMethod?.cardHolderName}
                                validators={[{
                                    condition: () => !this.nameInput.isEmpty()
                                }]} onBlur={() => this.nameInput.validate()} onChange={() => this.options.onChange()}/>,
                <div className={styleSheet.cardIcons}>
                    <VisaIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                    <MasterCardIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                    <AmExIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                </div>,
                <CardInput ref="cardInput" onChange={() => this.options.onChange()}/>,
            ]
    }

    isValid() {
        if (Controller.paymentMethod.haveAltPaymentEnabled()) {
            return true;
        }
        return this.cardInput?.isInputComplete() && this.nameInput?.isValid();
    }

    getExtraCardData() {
        let result = {};
        if (this.nameInput) {
            result.name = this.nameInput.getValue();
            Controller.paymentMethod.cardHolderName = result.name;
        }
        return result;
    }

    // TODO @cleanup deduplicate this shit code
    confirmCard(callback, errorCallback) {
        this.cardInput.confirmCard(callback, errorCallback, this.getExtraCardData());
    }

    confirmCardWithoutStoring(scope, callback, errorCallback) {
        if (this.cardInput) {
            this.cardInput.confirmCardWithoutStoring(scope, callback, errorCallback, this.getExtraCardData());
        } else {
            callback({});
        }
    }
}
